import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: theme.spacing(2, 0),
        fontSize: 26,
        color: '#393a40'
    },
}));

export const Title = ({ children, style }) => {
  const classes = useStyles();
  return ( <Typography variant="h4" style={style} gutterBottom className={classes.title} >{children}</Typography> );
}

export default Title;